import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import SwitcherComponent from './SwitcherComponent';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class SnapToElement extends Component{

  @observable trans = {

  };

  @observable checked = false;

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

  }

  componentDidMount(){
    this.checked = Settings.getSettingsSnapToElementOnOff;
  }

  @action onChange = (e) => {

    this.checked = !this.checked;

    if (this.checked) {
      Settings.snapToElementOn();
    }
    else {
      Settings.snapToElementOff();
    }
  }

  render() {

    const t = this.t;
    const onColor = '#4bccc0';
    const onHandleColor='#fff';

    return (

        <div className="SnapToElement">
          <SwitcherComponent
            onChange={this.onChange}
            checked={this.checked}
            id="gridCheckbox"
            value="1"
            dictionaryStorage={this.props.dictionaryStorage}
          />
        </div>

    );


   // ReactDOM.render(dom, document.getElementById('transforms'));

  }
}


